import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isUnsupportedSafariOrIos } from '@zaoblako/web/core/utils/safari-ios-version.util';
import * as detect from 'detect-browser';

export const UnsupportedVersionGuard: CanActivateFn = () => {
  const router = inject(Router);
  const browser = detect.detect();
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';

  if (isUnsupportedSafariOrIos(browser, userAgent)) {
    router.navigate(['/unsupported-version']).catch(console.error);
    return false;
  }

  return true;
};
